import { Injectable } from '@angular/core';
import { MenuSetup, MenuEmployeeInformation, MenuTimeKeeping, MenuInsurancesAndOther, MenuSalaryCalculation,
    } from '../models/Other/menu.model';

@Injectable()
/**
 * menu data service
 */
export class MenuDataService {

    // Get Menu GL
    getMenuSetup(AccessFoSetup: string[]) {
        return MenuSetup;
        return MenuSetup.filter(function (number) {
            return AccessFoSetup.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuEmployeeInformation(AccessFoEmployeeInformation: string[]) {
        return MenuEmployeeInformation;
        return MenuEmployeeInformation.filter(function (number) {
            return AccessFoEmployeeInformation.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuTimeKeeping(AccessFoTimeKeeping: string[]) {
        return MenuTimeKeeping;
        return MenuTimeKeeping.filter(function (number) {
            return AccessFoTimeKeeping.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuInsurancesAndOther(AccessFoSalaryCalculation: string[]) {
        return MenuInsurancesAndOther;
        return MenuInsurancesAndOther.filter(function (number) {
            return AccessFoSalaryCalculation.indexOf(number.RouterLink) > -1;
        });
    }
    getMenuSalaryCalculation(AccessFoInsurancesAndOther: string[]) {
        return MenuSalaryCalculation;
        return MenuSalaryCalculation.filter(function (number) {
            return AccessFoInsurancesAndOther.indexOf(number.RouterLink) > -1;
        });
    }
}
